import { CategoryDataRecord } from "./categorydatarecord";
import { ConfigMaxSetAttributes } from "./configmaxsetattributes";

export class PublishAttributesRequest{
    prodId: number;
    relId: number;
    publishType: number;
    page: number;
    size: number;
}


// WEBPACK FOOTER //
// ./src/app/models/publishattributesreq.ts